module.exports = __webpack_public_path__ + "img/depmap_svg_V28.ae456d71.svg";